var map = {
	"./IDCardA.svg": "d5a5",
	"./IDCardB.svg": "b5a5",
	"./add-icon-old.png": "e680",
	"./add-icon-red-old.png": "67a7",
	"./add-icon-red.png": "e859",
	"./add-icon.png": "e9a7",
	"./address.png": "d0fa",
	"./ai.png": "45c9",
	"./approve-bg.png": "bd72",
	"./check-circle.png": "465a",
	"./clock-circle.png": "0bfa",
	"./default.png": "5cfc",
	"./default@2x.png": "fc76",
	"./delete-icon-old.png": "424a",
	"./delete-icon-red-old.png": "3ae5",
	"./delete-icon-red.png": "d5e9",
	"./delete-icon.png": "cdf3",
	"./finish_company.png": "71f5",
	"./finish_user.png": "3d52",
	"./follow-store.png": "2edb",
	"./fs-daifahuo.svg": "b3e9",
	"./fs-daishouhuo.svg": "8f4a",
	"./fs-qiyerenzheng.svg": "32a6",
	"./fs-quanbudingdan.svg": "af15",
	"./fs-shenhechenggong.png": "f63d",
	"./fs-shenheshibai.png": "d53d",
	"./fs-shenhezhong.png": "1dd4",
	"./fs-tuihuoshouhou.svg": "c50d",
	"./fs-yiwancheng.svg": "d1b4",
	"./fs-yuangongrenzheng.svg": "a127",
	"./info-circle.png": "8f06",
	"./logistic.png": "1b7a",
	"./minus-circle-fill.png": "9f74",
	"./more.png": "3b94",
	"./myWhitePay.png": "5324",
	"./navigator.png": "6f5c",
	"./net-fail.png": "3e62",
	"./radio-check.png": "a592",
	"./radio-indeterminate.png": "bf14",
	"./radio-uncheck.png": "59c9",
	"./scan.png": "f24a",
	"./step_done.png": "01b9",
	"./tab-category-active.png": "038b",
	"./tab-category.png": "e763",
	"./tab-goods-active.png": "7547",
	"./tab-goods.png": "3e83",
	"./tab-mall-active.png": "030f",
	"./tab-mall.png": "08f1",
	"./tab-my-active.png": "bbfd",
	"./tab-my.png": "5116",
	"./tab-salesSlip-active.png": "f579",
	"./tab-salesSlip.png": "5b60",
	"./tab-salespromotion-active.png": "4e8b",
	"./tab-salespromotion.png": "41cc",
	"./tab-salesstatistics-active.png": "61d3",
	"./tab-salesstatistics.png": "e3b6",
	"./tab-shelf-active.png": "cc54",
	"./tab-shelf.png": "21a7",
	"./tab-shopcar-active.png": "e449",
	"./tab-shopcar.png": "30d1",
	"./tab-workbench-active.png": "7e0d",
	"./tab-workbench.png": "caf1",
	"./toBePaid.png": "60f5",
	"./toBePaid@2x.png": "9b3f",
	"./toBePaid@3x.png": "c098",
	"./workbench-bg.png": "5688",
	"./workbench-white.png": "40e2",
	"./yingyezhizhao.svg": "55d7",
	"./免息权益.png": "8c28",
	"./微信支付.png": "093b",
	"./支付宝支付.png": "82af",
	"./白条快付.png": "b5e3",
	"./线下支付.png": "5fb0"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "3ef3";